module.exports = __webpack_public_path__ + "static/media/BDSmith.6dce04af.png";